/* eslint-disable no-undef */
class ActionScopeEnum {
  static INSTANCE = 'instance';
  static APPLICATION = 'application';
}

export const ActionScope = Object.freeze(ActionScopeEnum);
